// src/pages/Examination/ExaminationSession/workspaceStorage.js
//
// Muayene "devam et" akışı için UI state restore — son aktif tab + her tab'ın
// son açık kaydı localStorage'da saklanır. Sadece muayene modunda kullanılır;
// hasta detay sayfasında çağrılmaz.

const KEY_PREFIX = "pupill.exam.";
const KEY_SUFFIX = ".workspace";

const buildKey = (examinationId) =>
  `${KEY_PREFIX}${String(examinationId)}${KEY_SUFFIX}`;

const EMPTY_STATE = {
  activeTab: null,
  openRecords: {}, // { [tabKey: string]: recordId | null }
};

export function readWorkspaceState(examinationId) {
  if (!examinationId) return { ...EMPTY_STATE };
  try {
    const raw = window.localStorage.getItem(buildKey(examinationId));
    if (!raw) return { ...EMPTY_STATE };
    const parsed = JSON.parse(raw);
    return {
      activeTab: parsed.activeTab || null,
      openRecords:
        parsed.openRecords && typeof parsed.openRecords === "object"
          ? parsed.openRecords
          : {},
    };
  } catch (_) {
    return { ...EMPTY_STATE };
  }
}

export function writeWorkspaceState(examinationId, updater) {
  if (!examinationId) return;
  try {
    const prev = readWorkspaceState(examinationId);
    const next =
      typeof updater === "function" ? updater(prev) : { ...prev, ...updater };
    window.localStorage.setItem(buildKey(examinationId), JSON.stringify(next));
  } catch (_) {
    // localStorage tam dolu / disabled — sessizce yok say.
  }
}

export function clearWorkspaceState(examinationId) {
  if (!examinationId) return;
  try {
    window.localStorage.removeItem(buildKey(examinationId));
  } catch (_) {
    // ignore
  }
}
